import { fetchAll } from './fetch';
import Subfamily from 'models/subfamily';

export default fetchAll('subfamily', Subfamily, []);
